/* eslint-disable camelcase */
import dynamic from 'next/dynamic';
import { FlexBox } from '@/styles/index';
import { Icon } from 'react-icons-kit';
import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right';
// import Modal from '@/components/Modal';
const Modal = dynamic(() => import('@/components/Modal'));
// import Poll from '@/components/Poll';
const Poll = dynamic(() => import('@/components/Poll'));

const TemplateDetailsModal = ({ isOpen, toggleModal, onSelectTemplate, poll, ...rest }) => {
  const handleUseTemplate = () => {
    onSelectTemplate();
  };

  const ModalFooter = (
    <>
      <button type="button" className="cancel-btn" onClick={toggleModal}>
        Close
      </button>
      <div className="continue-btn">
        <button type="button" onClick={handleUseTemplate}>
          Use template <Icon size={24} icon={ic_chevron_right} />
        </button>
      </div>
    </>
  );
  return (
    <Modal
      isOpen={isOpen}
      toggleModal={toggleModal}
      header={poll.title}
      footer={ModalFooter}
      gtc="100px 150px"
      modalHeight="90vh"
      modalWidth="80vw"
      // footerOptions={1}
      {...rest}
    >
      <FlexBox>
        <Poll poll={poll} model={poll.model} examples onEditor />
      </FlexBox>
    </Modal>
  );
};

export default TemplateDetailsModal;
